import { GcpVmTableData } from './types';
import { GcpVmResourceDetails } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

export const mapResourcesToGcpVmTableData = (
  resources: GcpVmResourceDetails[],
): GcpVmTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      name: resource.name,
      zone: resource.zone,
      machineType: resource.machineType,
      status: resource.status,
    };
    return baseData;
  });
};
